import { orchestrator } from 'satcheljs';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { setFavoriteBitFlag, FavoritesBitFlagsMasks } from 'owa-favorites';
import { getUserConfiguration } from 'owa-session-store';
import setFirstRunFavoritesMigrationBit from '../actions/v2/setFirstRunFavoritesMigrationBit';

export default orchestrator(setFirstRunFavoritesMigrationBit, actionMessage => {
    const userOptions = getUserConfiguration().UserOptions;

    // Update the local user configuration store
    setFavoriteBitFlag(true /* value*/, FavoritesBitFlagsMasks.FirstRunFavoritesMigration);

    // Send out request to update FavoritesBitFlags
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['FavoritesBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [`${userOptions.FavoritesBitFlags}`],
            }),
        }),
    ]);
});
